import {
	createTypes,
	createAsyncAction,
} from '../../../flux';


type ActionTypes = {
	'FETCH_SESSION_CONTEXT': string;
	'FETCH_TENANT_BY_ID': string;
	'UPDATE_TENANT': string;
	'FETCH_TENANT_ACCOUNT': string;
	'FETCH_ACCESS_TOKENS': string;
	'GENERATE_ACCESS_TOKEN': string;
	'REVOKE_ACCESS_TOKEN': string;
};

const types = createTypes<ActionTypes>([
	'FETCH_SESSION_CONTEXT',
	'FETCH_TENANT_BY_ID',
	'UPDATE_TENANT',
	'FETCH_TENANT_ACCOUNT',
	'FETCH_ACCESS_TOKENS',
	'GENERATE_ACCESS_TOKEN',
	'REVOKE_ACCESS_TOKEN',
], 'BUSINESS:TENANT');

const actions = {
	fetchSessionContext: createAsyncAction<ClientSessionContext>(types.FETCH_SESSION_CONTEXT)(
		(box, ticketUID: string) => box.api.platform.auth.security.rest.fetchSessionContext(ticketUID),
	),
	fetchTenantByID: createAsyncAction<Tenant>(types.FETCH_TENANT_BY_ID)(
		(box, tenantID: number) => box.api.platform.security.directoryService.fetchTenantByID(tenantID),
	),
	updateTenant: createAsyncAction<Tenant>(types.UPDATE_TENANT)(
		(box, tenant: Tenant) => box.api.platform.security.directoryService.updateTenant(tenant),
	),
	fetchTenantAccount: createAsyncAction<TenantAccount>(types.FETCH_TENANT_ACCOUNT)(
		(box, tenantID: number) => box.api.platform.billing.billingService.fetchTenantAccount(tenantID),
	),
	fetchAccessTokens: createAsyncAction<Array<OAuthAccessToken>>(types.FETCH_ACCESS_TOKENS)(
		(box) => box.api.platform.security.authorizationService.fetchAccessTokens(),
	),
	generateAccessToken: createAsyncAction<OAuthAccessToken>(types.GENERATE_ACCESS_TOKEN)(
		(box) => box.api.platform.security.authorizationService.generateAccessToken(),
	),
	revokeAccessToken: createAsyncAction<boolean>(types.REVOKE_ACCESS_TOKEN)(
		(box, tokenValue: string) => box.api.platform.security.authorizationService.revokeAccessToken(tokenValue),
	),
};

export const tenantActionsPack = {
	types,
	actions,
};
